import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
  MatBottomSheet,
} from '@angular/material/bottom-sheet';
import { kitchenSearchItem } from 'src/app/core/model/api-response/cooking-story-model';
import { foodUnitRatioArray } from 'src/app/core/model/api-response/persoanl-response-model';
import { CookingStoryShoppinglistDateService } from 'src/app/data/repository/cooking-story/cooking-story-shoppinglist-date.service';
import { KitchenSearchUnitComponent } from '../../../kitchen/kitchen-search/kitchen-search-edit/kitchen-search-unit/kitchen-search-unit.component';
import { ShoppingListSearchEditComponent } from '../shopping-list-search-edit/shopping-list-search-edit.component';

@Component({
  selector: 'app-shopping-list-search-edit-unit',
  templateUrl: './shopping-list-search-edit-unit.component.html',
  styleUrls: ['./shopping-list-search-edit-unit.component.scss'],
})
export class ShoppingListSearchEditUnitComponent implements OnInit {
  SWIPE_ACTION = { UP: 'swipeup', DOWN: 'swipedown' };
  foodUnitRatioArray: foodUnitRatioArray[];
  activeId: string;
  item: kitchenSearchItem;
  unitList;
  selectedRatio: string;
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: {
      name: string;
    },
    private bottomSheetRef: MatBottomSheetRef<ShoppingListSearchEditUnitComponent>,
    private matBottomSheet: MatBottomSheet,
    private cookingStoryShoppinglistDateService: CookingStoryShoppinglistDateService
  ) {}

  async ngOnInit() {
    this.activeId = this.cookingStoryShoppinglistDateService.getActiveItem();
    this.item = this.cookingStoryShoppinglistDateService.getItem(this.activeId);
    const unsaved = this.cookingStoryShoppinglistDateService.getUnsavedItem(
      this.activeId
    );
    if (unsaved) {
      this.selectedRatio = unsaved;
    } else {
      this.selectedRatio = this.item.unit;
    }
    this.unitList =
      await this.cookingStoryShoppinglistDateService.getUnitList();
  }
  swipe(action: string = this.SWIPE_ACTION.DOWN) {
    if (action === this.SWIPE_ACTION.DOWN) {
      this.goBack();
    }
  }
  goBack() {
    const bottomSheetRef = this.matBottomSheet.open(
      ShoppingListSearchEditComponent,
      {
        panelClass: 'custom-bottomsheet-container',
      }
    );
  }
  getUnitName(id: string) {
    if (!id || id == 'nothing' || id == '') {
      return 'بدون واحد';
    }
    const unit = this.unitList?.filter((d) => {
      return id == d._id;
    })[0];

    return unit?.name;
  }
  checkSelect(id) {
    if (id == 'nothing' || id == '' || !id) {
      if (this.selectedRatio == 'nothing') {
        return true;
      }
    }
    if (id == this.selectedRatio) {
      return true;
    }
    return false;
  }
  save(id: string) {
    // this.cookingStoryShoppinglistDateService.updateUnit(id);
    if (!id) {
      id = 'nothing';
    }

    this.cookingStoryShoppinglistDateService.addUnsaved(this.activeId, id);
    this.goBack();
  }
}
